export class SocialAuthenticateRequestModel {
    public token: string;
    // public username: string;
  }
  